(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-3d-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ah-hero3d').forEach(function(section){
    const stage = section.querySelector('[data-ah-stage]');
    const card = section.querySelector('[data-ah-card]');
    if(!stage || !card) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce) return;

    stage.addEventListener('mousemove', function(e){
      const r = stage.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = 'rotateY(' + (x*22) + 'deg) rotateX(' + (-y*18) + 'deg) translateZ(20px)';
    });
    stage.addEventListener('mouseleave', function(){
      card.style.transform = 'rotateY(0deg) rotateX(0deg) translateZ(0px)';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
